export { default as AttendeesTable } from './Attendees'
export { default as AttendancesTable } from './Attendances'
export { default as CompaniesTable } from './Companies'
export { default as DriversTable } from './Drivers'
export { default as LocationsTable } from './Locations'
export { default as ResultsTable } from './Results'
export { default as UsersTable } from './Users'



// WEBPACK FOOTER //
// ./src/browser/tables/index.js